import styles from "./Details.module.css";
import { Input } from "../../../common/Input";
import { Button } from "../../../common/Button";
import { ButtonFooter } from "../../../common/ButtonFooter";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { CustomPhoneInput } from "../../../common/PhoneInput";

export const Details = ({
  defaultPhone,
  onPay = () => {},
  isLoading,
}: {
  defaultPhone?: string;
  onPay: () => void;
  isLoading?: boolean;
}) => {
  const { handleSubmit, control, register, getValues } = useForm();

  const values = getValues();

  const [value, setValue] = useState(values);
  const [phoneVal, setPhoneVal] = useState(defaultPhone);

  const handleInputChange = (e: any) => {
    e.preventDefault();
    setValue({
      ...value,
      [e.target.inputId]: e.target.value,
    });
  };

  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit(onPay)}>
        <div className={styles.form}>
          <div className={styles.dualInput}>
            <Input
              register={register}
              inputId="firstName"
              type="text"
              labelfocus="First name"
              placeholder="First name"
              required
              onChange={handleInputChange}
            />
            <Input
              register={register}
              inputId="lastName"
              type="text"
              labelfocus="Last name"
              placeholder="Last name"
              required
              onChange={handleInputChange}
            />
          </div>

          <CustomPhoneInput
            register={register}
            inputId="phone"
            type="text"
            labelfocus="Phone number"
            placeholder="Phone number"
            control={control}
            value={phoneVal}
            setVal={setPhoneVal}
          />
        </div>
        <ButtonFooter showNote>
          <Button
            type="submit"
            text="Continue"
            buttonStyle="primary"
            isButtonLoading={isLoading}
            disabled={
              !values?.firstName?.length ||
              !values?.lastName?.length ||
              !phoneVal?.length
            }
          />
        </ButtonFooter>
      </form>
    </div>
  );
};
